import { render, staticRenderFns } from "./Welcome copy.vue?vue&type=template&id=332594a9&scoped=true&"
import script from "./Welcome copy.vue?vue&type=script&lang=js&"
export * from "./Welcome copy.vue?vue&type=script&lang=js&"
import style0 from "./Welcome copy.vue?vue&type=style&index=0&id=332594a9&scoped=true&lang=css&"
import style1 from "./Welcome copy.vue?vue&type=style&index=1&id=332594a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332594a9",
  null
  
)

component.options.__file = "Welcome copy.vue"
export default component.exports